import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { GUID_ZERO } from "./constants";

export function ForceSelectGuid(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Ensure the value is not empty or the default option (e.g., 'Select...').
    const isValid = control.value && control.value !== GUID_ZERO;
    return isValid ? null : { invalidSelect: true };
  };
}
